export const isSameOrigin = (input: RequestInfo | URL): boolean => {
  const urlString = input instanceof Request ? input.url : input.toString();
  return (
    new URL(urlString, window.location.origin).origin === window.location.origin
  );
};
